export const projects = [
  { name: 'Default', path: 'index.html' }, // first is the default one
  { name: 'Injected', path: 'index_injected.html' },
  { name: 'Injected Native', path: 'index_injected_native.html' }
];
